const hintPattern = '(?:[\\*+?()0-9]+)';
const rulePattern = '[a-zA-Z][a-zA-Z0-9_]+';
const ruleExtractor = new RegExp(
  `^(${hintPattern}?${rulePattern})(?:\\:(.*)+)?$`,
  'i',
);

function parseRule(rule: string): false | [string, string[]] {
  const trimmed = rule.trim();
  if (trimmed) {
    const matches = trimmed.match(ruleExtractor);
    if (matches && typeof matches[1] === 'string') {
      const ruleName = matches[1].trim();
      const args = matches[2] && typeof matches[2] === 'string'
        ? matches[2].split(',').map((s) => s.trim())
        : [];
      return [ruleName, args];
    }
  }
  return false;
}

export function extractFormkitRules(validation?: string | [string, ...any[]]) {
  if (typeof validation !== 'string') return validation;
  const validationRules = validation.split('|').reduce<[string, string[]][]>((rules, rule) => {
    const parsedRule = parseRule(rule);
    if (parsedRule) {
      rules.push(parsedRule);
    }
    return rules;
  }, []);

  return Object.fromEntries(validationRules);
}
